import React from 'react';
import { Box, CircularProgress, Alert } from '@mui/material';
import SchoolList from '../components/schools/SchoolList';
import { useSchoolsUS } from '../contexts/SchoolsContextUS';

const SchoolsUS: React.FC = () => {
  const { schools, loading, error } = useSchoolsUS();

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '200px' }}>
        <CircularProgress />
      </Box>
    );
  }

  if (error) {
    return (
      <Box sx={{ p: 2 }}>
        <Alert severity="error">{error}</Alert>
      </Box>
    );
  }

  return (
    <Box sx={{ p: 2 }}>
      <SchoolList schools={schools} useStateFilter={true} />
    </Box>
  );
};

export default SchoolsUS;
